/**
 * The program strip's context on its own (13 Oct 2026), so Book can read the program in view without loading the
 * provider's preferences and translations.
 */
import { createContext, useContext } from 'react';
import type { PeopleView } from '@shared/people-programs';
import type { MY_PROGRAMS } from '@shared/my-settings';

type Program = (typeof MY_PROGRAMS)[number];

export interface ProgramCtx {
  program: Program;
  setProgram: (p: Program) => void;
  peopleView: PeopleView;
  setPeopleView: (v: PeopleView) => void;
  /** Whether this person has the house Today at all (the administrator, a co-administrator): `/` is always Today for them (26 Oct 2026). */
  hasToday: boolean;
}
export const ProgramCtxValue = createContext<ProgramCtx | null>(null);

/** The program state when there is one (Book reads it to open on the program in view); null outside the provider. */
export function useProgramMaybe() {
  return useContext(ProgramCtxValue);
}
